import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationComponent } from './notification.component';
import { NotificationType } from './notificationType.enum';

@Injectable()
export class UserNotificationService {
  constructor(private readonly newNotification: MatSnackBar) {}

  public sendPositive(message: string, showFor = 3000): void {
    this.sendNotification(message, NotificationType.POSITIVE, showFor);
  }
  public sendNegative(message: string, showFor = 3000): void {
    this.sendNotification(message, NotificationType.NEGATIVE, showFor);
  }
  public sendWarning(message: string, showFor = 3000): void {
    this.sendNotification(message, NotificationType.WARNING, showFor);
  }
  public sendNotification(message: string, type: NotificationType, showFor = 3000): void {
    this.newNotification.openFromComponent(NotificationComponent, {
      panelClass: ['ev-snackbar'],
      duration: showFor,
      data: {
        message,
        type,
      },
    });
  }
}
